import { z } from 'zod';
import { AppEnvironment } from '@/types/environment';
import { AppPlatform } from '@trinity/chat';

export const BoolLikeSchema = z.union([z.string(), z.boolean()]).transform(value => typeof value === 'boolean' ? value : /^(t(?:rue)*)|(y(?:es)*)$/i.test(value));
export const NumberLikeSchema = z.union([z.string(), z.number()]).pipe(z.coerce.number());

export const AppConfigSchema = z.object({
  APP_ENVIRONMENT: AppEnvironment,
  APP_PLATFORM: AppPlatform,

  VEEVA_AUTH_PROVIDER: z.enum(['ping', 'entra']).default('ping'),

  BRAND_INSIGHTS_API_URL: z.string().url(),
  BRAND_INSIGHTS_WS_PATH: z.string(),
  BRAND_INSIGHTS_WS_URL: z.string().url(),

  FRONT_BASE_URL: z.string().url(),

  SENTRY_ENABLED: BoolLikeSchema,
  SENTRY_DSN: z.string().url().optional(),
  SENTRY_RELEASE: z.string().optional(),

  USERNAME_PASSWORD_LOGIN_ENABLED: BoolLikeSchema,

  DEMO_ENV: BoolLikeSchema.default(false),

  // Trinity Edge SSO
  TRINITY_EDGE_BASE_URL: z.string().url().optional(),
  TRINITY_EDGE_PLATFORM_ID: z.string().optional(),

}).readonly().refine(
  data => !data.SENTRY_ENABLED || (data.SENTRY_ENABLED && data.SENTRY_DSN),
  {
    message: "SENTRY_DSN is required when SENTRY_ENABLED is true",
    path: ["SENTRY_DSN"],
  }
);

export type AppConfig = z.infer<typeof AppConfigSchema>;